import React, { useState } from "react";
import Icon from "@mdi/react";
import { mdiAccountTie } from "@mdi/js";
import { Tabs, Tab } from "@mui/material";
import { MainLayout } from "layouts";
import { useWorkspaceData } from "shared/hooks";
import { CatalogTab } from "./CatalogTab";
import { ContractedTab } from "./ContractedTab";
import styles from "./styles.module.scss";

type TabKey = "contracted" | "catalog";

export const SpecialistsPage: React.FC = () => {
	const { workspace } = useWorkspaceData();
	const workspaceId = workspace ? String(workspace.id) : null;
	const [tab, setTab] = useState<TabKey>("contracted");

	return (
		<MainLayout>
			<div className={styles.container}>
				<div className={styles.header}>
					<div className={styles.headerTitleWrap}>
						<Icon path={mdiAccountTie} size={1.2} />
						<h2 className={styles.title}>Membros Especialistas</h2>
					</div>
					<p className={styles.subtitle}>
						Gerencie os profissionais IA contratados nas suas equipes — promova/rebaixe senioridade, adicione ou remova ferramentas — ou
						explore o catálogo de templates disponíveis para contratação.
					</p>
				</div>

				<Tabs
					value={tab}
					onChange={(_, v) => setTab(v as TabKey)}
					className={styles.tabs}
					textColor="primary"
					indicatorColor="primary"
				>
					<Tab value="contracted" label="Meus Contratados" />
					<Tab value="catalog" label="Catálogo" />
				</Tabs>

				<div className={styles.tabPanel}>
					{tab === "contracted" ? <ContractedTab workspaceId={workspaceId} /> : <CatalogTab workspaceId={workspaceId} />}
				</div>
			</div>
		</MainLayout>
	);
};
